/**
 * @param {object} params
 * @param {boolean} [params.irsReportingRequired] - from quote API QuoteStatusItem.IRSReportingRequired
 * @param {boolean} [params.hasFullTaxIdOnFile] - from GET accounts/{uid}/settings
 * @returns {{ irsReportingRequired: boolean, requiresSsnUi: boolean }}
 */
export function resolveSfhSellTaxComplianceGate({
  irsReportingRequired = false,
  hasFullTaxIdOnFile = false,
}) {
  const requiresSsnUi = irsReportingRequired && !hasFullTaxIdOnFile;
  return { irsReportingRequired, requiresSsnUi };
}
